/** Root element vanilla-cookieconsent renders its consent banner and preferences modal into. */
export const COOKIE_CONSENT_ROOT_SELECTOR = "#cc-main";
